// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Contact-___contact__container___34lh7","page-content":"src-components-Contact-___contact__page-content___3P8M9","para-text":"src-components-Contact-___contact__para-text___3_NMa","text-content":"src-components-Contact-___contact__text-content___3F3mb","contact-list":"src-components-Contact-___contact__contact-list___1uFgj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/contact.css
// module id = 820
// module chunks = 0